import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { KOSHER_AUTHORITIES } from '@/lib/kosherLabels';

export interface AuthorityCount {
  authority: string;
  count: number;
}

export const useKosherAuthorityCounts = () => {
  return useQuery({
    queryKey: ['kosher-authority-counts'],
    queryFn: async () => {
      // Get all validated places with kosher_authority
      const { data, error } = await supabase
        .from('places')
        .select('kosher_authority')
        .eq('verification_status', 'validated')
        .not('kosher_authority', 'is', null);

      if (error) throw error;

      // Count by authority filter value
      const counts: Record<string, number> = {};
      
      KOSHER_AUTHORITIES.forEach(auth => {
        counts[auth.value] = 0;
      });

      data?.forEach((place) => {
        const authority = place.kosher_authority?.toLowerCase() || '';
        
        // Match against our filter values
        KOSHER_AUTHORITIES.forEach(auth => {
          if (authority.includes(auth.value.toLowerCase())) {
            counts[auth.value]++;
          }
        });
      });

      return counts;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
